import React from "react";

import { DashboardPageBody } from "../../components/Page";
import DashboardContent from "./ui";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import Footer from "../../widgets/Footer";

function Dashboard() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <DashboardPageBody>
        <DashboardContent />
        <Footer />
      </DashboardPageBody>
    </DashboardLayout>
  );
}

export default Dashboard;
